<div class="social-media-container">
  <div class="header d-flex justify-content-start align-items-center">
    <h3 class="fontsize16 font700">{{ 'view_translations.choose_social_media' | translate}}</h3>
  </div>
  <div *ngIf="currentMode === 'chooseType' || currentMode === 'chosen'">
    <div class="row no-gutters">
      <div
        *ngFor="let type of socialMediaTypes; index as i"
        class="col-6 col-sm-4 col-md-3"
        [ngClass]="{'d-none': !showAll && i>3, 'active': currentSelectedType}">
        <div class="d-flex justify-content-center">
          <app-label-container
            (selectedSource)="onSelectSource($event)"
            [id]="type.id ?? 0"
            [icon]="setIcon(type?.id ?? 0)"
            [active]="type.id === currentSelectedType?.id">
          </app-label-container>
        </div>
      </div>
    </div>
    <div class="text font500 pointer" (click)="onShowAll()">
      <ng-container *ngIf="!showAll"> {{ 'view_translations.expand' | translate }} (+{{counter - defaultNumberOfTiles}}) </ng-container>
    </div>
  </div>
</div>
